export default __webpack_public_path__ + "static/media/12.edfb219c.svg";